import { ComponentProps, ReactNode } from 'react';
import { NavigationCard } from '../navigation-card/navigation-card';
import {
    ROUTE_ADMIN_APPEALS,
    ROUTE_ADMIN_APPROVE,
    ROUTE_ADMIN_APPROVE_ORDERS,
    ROUTE_ADMIN_CATALOG,
    ROUTE_ADMIN_CATALOGS,
    ROUTE_ADMIN_ORDERS,
    ROUTE_ADMIN_EMPLOYEES,
    ROUTE_ADMIN_FILES,
    ROUTE_ADMIN_ORGANIZATIONS,
    ROUTE_ADMIN_USERS,
} from '@shared/config/routes/routes';
import {
    AllDialog,
    AllDownload,
    Directory,
    Employees,
    OnYourself,
    Services,
    Work,
} from '@vtbhome/juicyfront/indexIcon';
import { UserRoles } from '@shared/model/user';

export const TRANSITION_DURATION = '.15s';
export const FAST_TRANSITION_DURATION = '.12s';

interface LinkByRole {
    linkProps: ComponentProps<typeof NavigationCard>;
    Icon: ReactNode;
}

export const LINKS_BY_ROLE: Record<UserRoles, LinkByRole[]> = {
    admin: [
        { linkProps: { href: ROUTE_ADMIN_USERS, text: 'Пользователи' }, Icon: <Employees /> },
        { linkProps: { href: ROUTE_ADMIN_ORGANIZATIONS, text: 'Организации' }, Icon: <Work /> },
        { linkProps: { href: ROUTE_ADMIN_CATALOGS, text: 'Продукты и каталоги' }, Icon: <Directory /> },
        { linkProps: { href: ROUTE_ADMIN_ORDERS, text: 'Сделки' }, Icon: <OnYourself /> },
        { linkProps: { href: ROUTE_ADMIN_APPEALS, text: 'Обращения' }, Icon: <AllDialog /> },
        { linkProps: { href: ROUTE_ADMIN_FILES, text: 'Файлы' }, Icon: <AllDownload /> },
    ],
    user: [
        { linkProps: { href: ROUTE_ADMIN_CATALOG, text: 'Каталог' }, Icon: <Services /> },
        { linkProps: { href: ROUTE_ADMIN_APPROVE, text: 'Согласование' }, Icon: <Directory /> },
    ],
    manager: [
        { linkProps: { href: ROUTE_ADMIN_CATALOG, text: 'Каталог' }, Icon: <Services /> },
        { linkProps: { href: ROUTE_ADMIN_APPROVE_ORDERS, text: 'Сделки организации' }, Icon: <Directory /> },
        { linkProps: { href: ROUTE_ADMIN_EMPLOYEES, text: 'Сотрудники' }, Icon: <Employees /> },
    ],
};
